<script setup lang="ts">
import { computed } from '#imports';
import { UiSize, UiTheme } from '../../styles/Styles';

const props = withDefaults(defineProps<{
  theme?: UiTheme | 'custom';
  size?: UiSize;
  href?: string;
  to?: string | object;
  newTab?: boolean;
  disabled?: boolean;
  locale?: string;
  qa?: string;
  link?: boolean;
  wrap?: boolean;
}>(), {
  theme: UiTheme.Primary,
  size: UiSize.Medium,
  to: '',
  newTab: false,
  disabled: false,
  locale: '',
  qa: '',
  link: false,
  wrap: false,
});

const classView = computed(() => {
  const result = [];
  
  result.push(`_${props.theme}`);
  result.push(`_${props.size}`);
  if (props.disabled) result.push('_disabled');
  if (props.link) result.push('_link');
  if (props.wrap) result.push('_wrap');
  
  return result;
});

defineEmits(['click']);
</script>

<template lang="pug">
NuxtLink.ui-link-as-button(
  :to="to || href"
  :external="!to"
  :class="classView"
  :target="newTab ? '_blank' : '_self'"
  :data-qa="qa + locale"
  @click="$emit('click', $event, to || href)"
)
  .button-icon.left-icon(
    v-if="$slots.leftIcon"
  )
    slot(name="leftIcon")
  slot {{ $t(locale) }}
  .button-icon.right-icon(
    v-if="$slots.rightIcon"
  )
    slot(name="rightIcon")
</template>

<style lang="scss" scoped>
@import '../../styles/button';

.ui-link-as-button {
  @include ui-button-styles;
  text-decoration: none;

  &._disabled {
    pointer-events: none;
  }
}
</style>
